import { motion } from "framer-motion";
import { Mole } from "./Mole";
import { CtaButton } from "./CtaButton";
import { Reveal } from "./Reveal";

export default function FinalCta({ onCta }) {
  return (
    <section className="relative overflow-hidden py-20 sm:py-28">
      <div
        aria-hidden="true"
        className="absolute left-1/2 top-1/2 h-96 w-96 -translate-x-1/2 -translate-y-1/2 rounded-full bg-nora-accent/10 blur-3xl"
      />
      <div className="relative mx-auto max-w-2xl px-4 text-center sm:px-6">
        <Reveal>
          <motion.div
            animate={{ y: [0, -8, 0] }}
            transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            className="mx-auto w-24 sm:w-28"
          >
            <Mole data-testid="final-cta-mascot" variant="hi" className="w-full" />
          </motion.div>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-4xl font-black tracking-tight sm:text-5xl">
            Пора в нору
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-8 flex justify-center">
            <CtaButton onClick={onCta} testId="final-cta-button" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
